export const T_PREFIX = "bread-crumbs";

export const breadCrumbsTrns = {
  home: `${T_PREFIX}.home`,
  clones: `${T_PREFIX}.clones`,
  inquiries: `${T_PREFIX}.inquiries`,
  contactUs: `${T_PREFIX}.contact-us`,
  blog: `${T_PREFIX}.blog`,
};
